// extracted by mini-css-extract-plugin
export default {"tooltip":"CopiesField_tooltip__Xbqja"};